import { Component, computed, inject } from '@angular/core';
import { MetricsService } from '@portal/app/dashboard/context-modal/services/metrics.service';
import { ModalService } from '@portal/app/dashboard/context-modal/services/modal.service';
import { MetricsResponseDTO } from '@portal/app/dashboard/context-modal/context-model.types';

@Component({
  selector: 'portal-context-metrics',
  templateUrl: './metrics.component.html',
  styleUrls: ['./metrics.component.scss'],
  providers: [MetricsService],
  standalone: false
})
export class MetricsComponent {
  metricsService = inject(MetricsService);
  private modalService = inject(ModalService);

  isLoading = this.metricsService.isLoading;
  data = this.metricsService.data;
  isDataAvailable = this.metricsService.isDataAvailable;
  activeTabIndex = this.metricsService.activeTabIndex;
  isSpendLevel = this.modalService.isSpendLevel;

  constructor() {
    this.metricsService.setActiveTabIndex(0);
  }

  onTabChange(value: number): void {
    this.metricsService.setActiveTabIndex(value);
  }

  filteredData = computed(() => {
    const data = this.data();
    const isSpendLevel = this.isSpendLevel();

    if (isSpendLevel) {
      return data.filter(
        (metric: MetricsResponseDTO) => metric.literalId !== 'percInc'
      );
    }
    return data;
  });
}
